// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"34e9bdd4","594":"3144f5f0","697":"df724974"}[chunkId] + ".chunk.css";
};